import { apiGet } from './utils';
import type { PagedResponse } from '../types';

// ---- Types (mirror backend src/models/fhteam.py to_json + blueprint) ----

export interface FHTeamSummary {
  key: string;
  uuid: string | null;
  team_name: string | null;
  master_user_name: string | null;
  master_user_email: string | null;
  member_count: number;
  is_billing: boolean;
  date_created: string | null;
}

export interface FHTeamMember {
  key: string;
  uuid: string | null;
  name: string;
  email: string;
}

export interface FHTeamInviteStatus {
  paid: boolean;
  activated: boolean;
  email_sent: boolean;
  revoked: boolean;
  cancelled: boolean;
}

export interface FHTeamInvite {
  key: string;
  invite_email: string | null;
  current_plan: string | null;
  new_plan: string | null;
  user_name: string | null;
  status: FHTeamInviteStatus;
  billing_error: string | null;
  date_created: string | null;
}

export interface FHTeamPayment {
  key: string;
  product_id: string | null;
  quantity: number;
  numeric_amount: number;
  amount: string | null;
  success: boolean;
  tasks_expire: string | null;
  subscription_id: string | null;
  date_created: string | null;
}

export interface FHTeamDetail {
  team: FHTeamSummary;
  master_user: FHTeamMember | null;
  members: FHTeamMember[];
  invites: FHTeamInvite[];
  payments: FHTeamPayment[];
}

export interface BillingMismatchRow {
  plan_code: string;
  recurly_quantity: number;
  local_count: number;
  sub_uuids: string[];
  current_period_ends_at: string | null;
}

export interface BillingMismatchResult {
  team_key: string;
  recurly_account: string | null;
  mismatches: BillingMismatchRow[];
  ok: BillingMismatchRow[];
  note?: string;
  error?: string;
}

// ---- API (manager-only; backend gates on is_manager) ----

export const teamAdminApi = {
  list(cursor?: string): Promise<PagedResponse<FHTeamSummary>> {
    return apiGet<PagedResponse<FHTeamSummary>>('/team-admin/list', { cursor });
  },

  detail(teamKey: string): Promise<FHTeamDetail> {
    return apiGet<FHTeamDetail>('/team-admin/detail', { team_key: teamKey });
  },

  billingMismatch(teamKey: string): Promise<BillingMismatchResult> {
    return apiGet<BillingMismatchResult>('/team-admin/billing-mismatch', { team_key: teamKey });
  },
};
